import classNames from "classnames";
import { useRouter } from "next/router";
import React from "react";

import { ROUTES } from "shared/constants";

import Img from "@components/FileServer/Img";
import FormattedMessage from "@components/UI/FormattedMessage";
import ShareModal from "@components/UI/ShareModal";

import useShareInfo from "../../../hooks/results/useShareInfo";

function Divider() {
  return <div className="search-steps-divider" />;
}

interface StepProps {
  activeStep: number;
  stepNumber: number;
  text: React.ReactElement;
}

function Step({ activeStep, stepNumber, text }: StepProps) {
  const active = activeStep === stepNumber;
  const finished = activeStep > stepNumber;
  return (
    <>
      <span
        className={classNames("search-steps-circle", {
          "search-steps-circle-active": active,
          "search-steps-circle-finished": finished,
        })}
      >
        {finished ? (
          <Img src="/static/images/ico-check.svg" alt="check icon" />
        ) : (
          stepNumber
        )}
      </span>
      <span
        className={classNames("search-steps-label", {
          "search-steps-label-active": active,
          "search-steps-label-finished": finished,
        })}
      >
        {text}
      </span>
    </>
  );
}

function goBack() {
  window.history.back();
}

interface Props {
  page: string;
}

function SearchSteps({ page }: Props) {
  const router = useRouter();
  let activeStep = 1;
  if (page === "result" || page === "hotel") {
    activeStep = 2;
  }
  if (page === "booked" || page === "hotelBook") {
    activeStep = 3;
  }
  if (page === "hotelBooked") {
    activeStep = 4;
  }

  const shareInfo = useShareInfo();

  return (
    <div className="search-steps">
      <div className="search-steps-desktop">
        <div className="container" style={{ position: "relative" }}>
          {["result", "hotel", "hotelBook"].includes(page) ? (
            <span className="button-back-result" onClick={goBack} role="button">
              <span className="fas fa-angle-left" />
              <span className="label-button-back-result bold">
                <FormattedMessage id="SearchSteps.back" />
              </span>
            </span>
          ) : (
            <span />
          )}

          <Step
            activeStep={activeStep}
            stepNumber={1}
            text={
              page.includes("hotel") ? (
                <FormattedMessage id="SearchSteps.chooseHotel" />
              ) : (
                <FormattedMessage id="SearchSteps.chooseFlight" />
              )
            }
          />

          {page.includes("hotel") && (
            <>
              <Divider />

              <Step
                activeStep={activeStep}
                stepNumber={2}
                text={<FormattedMessage id="SearchSteps.selectRooms" />}
              />
            </>
          )}

          <Divider />

          <Step
            activeStep={activeStep}
            stepNumber={page.includes("hotel") ? 3 : 2}
            text={<FormattedMessage id="SearchSteps.yourInformation" />}
          />

          <Divider />

          <Step
            activeStep={activeStep}
            stepNumber={page.includes("hotel") ? 4 : 3}
            text={<FormattedMessage id="Result.confirmBooking" />}
          />
        </div>
      </div>
      {router.pathname.includes(ROUTES.RESULTS) && (
        <ShareModal
          url={shareInfo?.url}
          title={shareInfo?.title}
          additionalInfo={shareInfo?.aditionalInfo}
          className="share-modal-toggle"
          showIcon
        />
      )}
    </div>
  );
}

export default SearchSteps;
